<template>
  <div>
    <b-row>
      <b-col xxs="12" class="d-flex align-items-center justify-content-between">
        <h3 class="mt-2">{{ $t("Kuru Temizleme Fişi") }}</h3>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col v-if="loading">
        <div style="width: 100%; text-align:center;">
          <b-spinner label="Spinning"></b-spinner>
        </div>
      </b-col>
      <b-col v-else>
        <ckeditor v-model="contract" editor-url="https://cdn.ckeditor.com/4.16.2/full/ckeditor.js" :config="config"/>
        <b-row class="mt-3">
          <b-col class="text-right">
            <b-button @click.prevent="send" variant="primary">{{ $t("Ayarları Kaydet") }}</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OrderContract',
  data() {
    return {
      loading: false,
      contract: '',
      config: {
        language: 'tr',
        height: 500,
        toolbarGroups: [
          { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
          { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
          { name: 'forms', groups: [ 'forms' ] },
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
          { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
          { name: 'links', groups: [ 'links' ] },
          { name: 'insert', groups: [ 'insert' ] },
          { name: 'styles', groups: [ 'styles' ] },
          { name: 'colors', groups: [ 'colors' ] },
          { name: 'tools', groups: [ 'tools' ] },
          { name: 'others', groups: [ 'others' ] },
          { name: 'about', groups: [ 'about' ] }
        ],
        removeButtons: 'Save,NewPage,ExportPdf,Preview,Print,Templates,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,PasteFromWord,CreateDiv,Language,Image,Flash,Iframe,About,ShowBlocks',
      }
    }
  },
  methods: {
    ...mapActions([ 'getDryContract','updateDryContract']),
    send() {
      this.updateDryContract({
        dry_contract: this.contract,
      }).then(response => {
        this.success(response.data.message)
      }).catch(error => {
        this.error(error.response.data.message)
      });
    },
  },
  mounted() {
    this.loading = true;
    this.config.allowedContent = true;
    this.getDryContract().then(response => {
      this.contract = response.data.contract;
      this.loading = false;
    })
  }
}
</script>
